module.exports = __webpack_public_path__ + "static/media/apple-button.2ea6bb50.svg";